import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';

const AsyncNewsletterSubscribeView = lazyForPaint(
    () => import(/* webpackChunkName: "async-newsletter-subscribe-view-jess" */ './index')
        .then(({ NewsletterSubscribeView }) => NewsletterSubscribeView)
);

export const NewsletterSubscribeView = () => <AsyncNewsletterSubscribeView />;
